/* tslint:disable */
/* eslint-disable */
/**
 * AllOfUs Workbench API
 * The API for the AllOfUs workbench.  Throughout, we use integer/int64 in preference to string/date-time because Swagger\'s date formatting is inconsistent between server and client. Time values are stored as milliseconds since the UNIX epoch.  Note: all requests tagged as \"cron\" must have the header X-Appengine-Cron: true, which app engine itself only sets when invoking as a cronjob. See https://cloud.google.com/appengine/docs/standard/java/config/cron#securing_urls_for_cron and o.p.w.interceptors.CronInterceptor which implements the header check. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Indicates the status of the workspace recovery flow (NOT_STARTED, REQUESTED, RECOVERING, RECOVERED, FAILED).
 * @export
 */
export const WorkspaceRecoveryStatus = {
    NOT_STARTED: 'NOT_STARTED',
    REQUESTED: 'REQUESTED',
    RECOVERING: 'RECOVERING',
    RECOVERED: 'RECOVERED',
    FAILED: 'FAILED'
} as const;
export type WorkspaceRecoveryStatus = typeof WorkspaceRecoveryStatus[keyof typeof WorkspaceRecoveryStatus];


export function WorkspaceRecoveryStatusFromJSON(json: any): WorkspaceRecoveryStatus {
    return WorkspaceRecoveryStatusFromJSONTyped(json, false);
}

export function WorkspaceRecoveryStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceRecoveryStatus {
    return json as WorkspaceRecoveryStatus;
}

export function WorkspaceRecoveryStatusToJSON(value?: WorkspaceRecoveryStatus | null): any {
    return value as any;
}

